import { ActionReducer, Action } from "@ngrx/store";
import { BookingsStore } from "@store/bookings";

export const bookingsReducer: ActionReducer<BookingsStore> = (state: BookingsStore = new BookingsStore(), action: Action) => {

  const s = BookingsStore.clone(state)

  switch(action.type) {

    case POPULATE_TIMESLOTS:
      s.timeslots = [...action.payload]
      return s

    case POPULATE_EDITABLE_BOOKING:
      s.editableBooking = action.payload
      return s

    case POPULATE_EDITABLE_WORKSHOP_ABSENCE:
      s.editableWorkshopAbsence = action.payload
      return s

    case POPULATE_AFFECTED_BOOKINGS:
      s.affectedBookings = [...action.payload]
      return s

    case POPULATE_POTENTIAL_BOOKING_STUDENTS:
      s.potentialStudents = [...action.payload]
      return s

    case POPULATE_REPLACEMENT_TUTORS:
      s.replacementTutors = [...action.payload]
      return s

    default:
      return state

  }
}

export const FETCH_TIMESLOTS = "FETCH_TIMESLOTS"
export const FETCH_TIMESLOTS_FAILURE = "FETCH_TIMESLOTS_FAILURE"
export const POPULATE_TIMESLOTS = "POPULATE_TIMESLOTS"
export const CREATE_BOOKING = "CREATE_BOOKING"
export const CREATE_BOOKING_FAILURE = "CREATE_BOOKING_FAILURE"
export const ADD_BOOKING = "ADD_BOOKING"
export const POPULATE_EDITABLE_BOOKING = "POPULATE_EDITABLE_BOOKING"
export const UPDATE_BOOKING = "UPDATE_BOOKING"
export const UPDATE_BOOKING_FAILURE = "UPDATE_BOOKING_FAILURE"
export const REPLACE_BOOKING = "REPLACE_BOOKING"
export const POPULATE_EDITABLE_WORKSHOP_ABSENCE = "POPULATE_EDITABLE_WORKSHOP_ABSENCE"
export const FETCH_AFFECTED_BOOKINGS = "FETCH_AFFECTED_BOOKINGS"
export const FETCH_AFFECTED_BOOKINGS_FAILURE = "FETCH_AFFECTED_BOOKINGS_FAILURE"
export const POPULATE_AFFECTED_BOOKINGS = "POPULATE_AFFECTED_BOOKINGS"
export const DELETE_BOOKING = "DELETE_BOOKING"
export const DELETE_BOOKING_FAILURE = "DELETE_BOOKING_FAILURE"
export const REMOVE_BOOKING = "REMOVE_BOOKING"
export const SAME_DAY_CANCEL_BOOKING = "SAME_DAY_CANCEL_BOOKING"
export const SAME_DAY_CANCEL_BOOKING_FAILURE = "SAME_DAY_CANCEL_BOOKING_FAILURE"
export const FETCH_POTENTIAL_BOOKING_STUDENTS = "FETCH_POTENTIAL_BOOKING_STUDENTS"
export const POPULATE_POTENTIAL_BOOKING_STUDENTS = "POPULATE_POTENTIAL_BOOKING_STUDENTS"
export const FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE = "FETCH_POTENTIAL_BOOKING_STUDENTS_FAILURE"
export const FETCH_REPLACEMENT_TUTORS = "FETCH_REPLACEMENT_TUTORS"
export const POPULATE_REPLACEMENT_TUTORS = "POPULATE_REPLACEMENT_TUTORS"
export const FETCH_REPLACEMENT_TUTORS_FAILURE = "FETCH_REPLACEMENT_TUTORS_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/bookings.ts